document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".reviews-slider").forEach((slider) => {

    const track = slider.querySelector(".reviews-track");
    const prev = slider.parentElement.querySelector(".reviews-prev");
    const next = slider.parentElement.querySelector(".reviews-next");

    const isMobile = () => window.innerWidth < 768;

    // Split desktop slides of 4 into mobile slides of 1
    function buildSlides() {
      // Reset to original state — remove any previously injected mobile slides
      track.querySelectorAll(".review-slide--mobile").forEach(el => el.remove());

      // Remove clones from previous init
      track.querySelectorAll(".review-slide[data-clone]").forEach(el => el.remove());

      if (!isMobile()) return;

      // For each desktop slide, split its cards into singles
      const desktopSlides = Array.from(track.querySelectorAll(".review-slide:not(.review-slide--mobile)"));

      desktopSlides.forEach((slide) => {
        const cards = Array.from(slide.children);

        // Create one mobile slide per card
        for (let i = 0; i < cards.length; i += 1) {
          const mobileSlide = document.createElement("div");
          mobileSlide.classList.add("review-slide", "review-slide--mobile");
          mobileSlide.appendChild(cards[i].cloneNode(true));

          // Insert mobile slide right after the desktop slide
          slide.after(mobileSlide);
        }

        // Hide the original desktop slide on mobile
        slide.style.display = "none";
      });
    }

    function initSlider() {
      // Clean up clones from a previous init
      track.querySelectorAll(".review-slide[data-clone]").forEach(el => el.remove());
      track.style.transition = "none";
      track.style.transform = "translateX(0)";

      buildSlides();

      // Gather whichever slides are now visible
      const slides = Array.from(track.querySelectorAll(
        isMobile() ? ".review-slide--mobile" : ".review-slide:not(.review-slide--mobile)"
      ));

      if (!slides.length) return;

      const totalSlides = slides.length;

      // Clone first and last for infinite loop
      const firstClone = slides[0].cloneNode(true);
      const lastClone  = slides[totalSlides - 1].cloneNode(true);
      firstClone.dataset.clone = "true";
      lastClone.dataset.clone  = "true";

      // Insert clones around the visible slide set
      slides[0].before(lastClone);
      slides[totalSlides - 1].after(firstClone);

      const allSlides = track.querySelectorAll(
        isMobile() ? ".review-slide--mobile, .review-slide[data-clone]" : ".review-slide:not(.review-slide--mobile), .review-slide[data-clone]"
      );

      let index = 1;

      // Force layout before re-enabling transition
      requestAnimationFrame(() => {
        track.style.transform = `translateX(-${index * 100}%)`;
      });

      function moveSlide() {
        track.style.transition = "transform 0.5s ease";
        track.style.transform = `translateX(-${index * 100}%)`;
      }

      // Replace old listeners by cloning buttons (removes previous event listeners)
      const newNext = next.cloneNode(true);
      const newPrev = prev.cloneNode(true);
      next.replaceWith(newNext);
      prev.replaceWith(newPrev);

      newNext.addEventListener("click", () => { index++; moveSlide(); });
      newPrev.addEventListener("click", () => { index--; moveSlide(); });

      // Touch swipe
      let touchStartX = 0;
      track.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener("touchend", (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return; // ignore tiny taps
        if (diff > 0) { index++; } else { index--; }
        moveSlide();
      }, { passive: true });

      track.addEventListener("transitionend", () => {
        const currentSlide = allSlides[index];
        if (!currentSlide) return;

        if (currentSlide.isEqualNode(firstClone)) {
          track.style.transition = "none";
          index = 1;
          track.style.transform = `translateX(-100%)`;
        }

        if (currentSlide.isEqualNode(lastClone)) {
          track.style.transition = "none";
          index = totalSlides;
          track.style.transform = `translateX(-${totalSlides * 100}%)`;
        }
      });
    }

    // Init on load
    initSlider();

    // Re-init if screen crosses the mobile breakpoint (e.g. rotation)
    let lastMobile = isMobile();
    window.addEventListener("resize", () => {
      const nowMobile = isMobile();
      if (nowMobile !== lastMobile) {
        lastMobile = nowMobile;
        initSlider();
      }
    });

  });

});